import React from "react";
// import { InputAdornment,useMediaQuery  } from "@mui/material";
import {
  StyledAvatar,
  StyledAvatarWrapper,
  StyledIcon,
  // StyledIconButton,
  StyledNavbar,
  // StyledNavbarSearch,
  StyledToolbar,
  // StyledWalletAmount,
  // StyledWalletBalance,
  // StyledWalletLabel,
  // StyledWalletText,
} from "./style";
// import { StyledBoxStyle, StyledSearchIcon } from "../input/style";
// import walletIcon from "../../../assets/svg/wallet.svg";
// import SettingsIcon from "../../../assets/svg/settings-icon.svg";
// import NotificationsIcon from "../../../assets/svg/notifications-icon.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProfilePlaceholder from "../profile-placeholder/ProfilePlaceholder";

const Navbar = () => {
  // const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);

  const getProfilePath = () => {
    if (profileDetails?.user_type === "admin") return "/admin/profile";
    if (profileDetails?.user_type === "personal_shopper") return "/personal-shopper/profile";
    return "/dashboard/profile";
  };

  const handleProfileClick = () => navigate(getProfilePath());

  return (
    <StyledNavbar>
      <StyledToolbar>
        {/* Top navbar search — hidden per requirement; do not remove */}
        {/* {!isMobile && (
          <StyledBoxStyle>
            <StyledNavbarSearch
              placeholder="Order / Shipment no"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <StyledSearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </StyledBoxStyle>
        )} */}
        <StyledIcon sx={{ marginLeft: "auto" }}>
          {/* <StyledWalletBalance>
            <img loading="lazy" src={walletIcon} alt="Wallet Icon" />
            <StyledWalletText>
              <StyledWalletLabel>Wallet Balance</StyledWalletLabel>
              <StyledWalletAmount>$0</StyledWalletAmount>
            </StyledWalletText>
          </StyledWalletBalance> */}
{/* 
          <StyledIconButton>
            <img loading="lazy" src={SettingsIcon} alt="settings Icon" />
          </StyledIconButton> */}
          {/* <StyledIconButton>
            <img loading="lazy" src={NotificationsIcon} alt="notification Icon" />
          </StyledIconButton> */}
          <StyledAvatarWrapper onClick={handleProfileClick}>
            {profileDetails?.profile_image ? (
              <StyledAvatar src={profileDetails.profile_image} alt="Profile" loading="lazy" />
            ) : (
              <ProfilePlaceholder size={40} showBorder />
            )}
          </StyledAvatarWrapper>
        </StyledIcon>
      </StyledToolbar>
    </StyledNavbar>
  );
};

export default Navbar;
